import { Sparkles } from "lucide-react";
import { DynamicIcon, iconNames, type IconName } from "lucide-react/dynamic";

const KNOWN_ICON_NAMES = new Set<string>(iconNames);

const isKnownIconName = (name: string): name is IconName => KNOWN_ICON_NAMES.has(name);

export interface QuickActionIconProps {
  name: string;
  className?: string;
}

/**
 * Renders the quick action's `icon` field (a lucide-react icon name, e.g.
 * "chart-column") without bundling every lucide icon — `DynamicIcon` lazy
 * loads only the ones actually used. Falls back to a generic icon for a name
 * the backend sends that this build of lucide doesn't recognize.
 */
export const QuickActionIcon = ({ name, className }: QuickActionIconProps) => {
  if (!isKnownIconName(name)) {
    return <Sparkles className={className} aria-hidden="true" />;
  }
  return <DynamicIcon name={name} className={className} aria-hidden="true" />;
};
